import { CSSProperties, ReactNode } from 'react';
import { getOptimalTextColor } from './Common/Edge';

export function CText(props: {
  type: 'H1' | 'H2' | 'subtitle' | 'body1' | 'body2' | 'body3' | 'button' | 'caption';
  color?: 'default' | 'white' | 'black' | 'primary' | 'secondary' | 'stroke' | 'error' | string;
  opacity?: number;
  pre?: boolean;
  children?: ReactNode;
  position?: 'left' | 'right' | 'center';
  baseColor?: string;
  className?: string;
}) {
  const style: CSSProperties = {};

  let color = 'text-[#404040] dark:text-white';
  if (props.color === 'white') {
    color = 'text-white';
  } else if (props.color === 'black') {
    color = 'text-black';
  } else if (props.color === 'primary') {
    color = 'text-[#FF3496]';
  } else if (props.color === 'secondary') {
    color = 'text-[#FF7700]';
  } else if (props.color === 'stroke') {
    color = 'text-[#333333]';
  } else if (props.color === 'error') {
    color = 'text-[#FB5A7A]';
  } else if (props.color) {
    color = '';
    style.color = props.color;
  }

  if (props.baseColor && props.baseColor.length > 0) {
    const actualColor = getOptimalTextColor(props.baseColor);
    color = '';
    style.color = actualColor;
  }

  let opacity = '';
  if (props.opacity !== undefined) {
    opacity = `opacity-${props.opacity * 100}`;
  }

  let className = '';
  if (props.type === 'H1') {
    className = `${color} ${opacity} text-[14px] font-bold`;
  } else if (props.type === 'H2') {
    className = `${color} ${opacity} text-[12px] font-bold`;
  } else if (props.type === 'subtitle') {
    className = `${color} ${opacity} text-[10px] font-bold`;
  } else if (props.type === 'body1') {
    className = `${color} ${opacity} text-[12px] font-normal`;
  } else if (props.type === 'body2') {
    className = `${color} ${opacity} text-[10px] font-normal`;
  } else if (props.type === 'body3') {
    className = `${color} ${opacity} text-[8px] font-normal`;
  } else if (props.type === 'button') {
    className = `${color} ${opacity} text-[12px] font-bold`;
  } else if (props.type === 'caption') {
    className = `${color} ${opacity} text-[10px] font-normal`;
  }
  if (props.className) className = `${className} ${props.className}`;

  let position = '';
  if (props.position == 'left') position = 'text-left';
  else if (props.position == 'right') position = 'text-right';
  else if (props.position == 'center') position = 'text-center';
  if (position) className = `${className} ${position}`;

  if (props.pre) {
    return (
      <span className={`${className} whitespace-pre-wrap break-all`} style={style}>
        {props.children}
      </span>
    );
  } else {
    return (
      <span className={`${className}`} style={style}>
        {props.children}
      </span>
    );
  }
}
